$(document).ready(() => {
    const updateTitleHeight = () => {
        let titleHeight = $(".brand_section .title_wrap").outerHeight(true);
        $(".brand_section .brand_links").css("--title-height", `${titleHeight}px`);
    };

    // Initial call
    updateTitleHeight();

    // Update on window resize
    $(window).on("resize", updateTitleHeight);
});
